import { Link } from "react-router-dom";
import SearchBar from "../components/SearchBar";
import BookList from "../components/BookList";
import { NEW_TESTAMENT } from "../data/books";

export default function Home() {
  return (
    <div data-testid="home-page" className="max-w-5xl mx-auto px-6 py-10">
      <div className="parchment-card p-7 md:p-10 fade-in">
        <p
          className="text-center"
          style={{
            fontFamily: "'IM Fell English', serif",
            fontStyle: "italic",
            color: "var(--ink-soft)",
            fontSize: "1.15rem",
            lineHeight: 1.6,
            margin: "0 auto 1.4rem",
            maxWidth: "60ch",
          }}
        >
          A Catholic Bible commentary compiled by the late Rev.&nbsp;Fr. George
          Leo Haydock, following the Douay&ndash;Rheims Bible &mdash; revised
          here for comfortable reading.
        </p>

        <div className="max-w-2xl mx-auto" data-testid="home-search">
          <SearchBar />
        </div>

        <div className="ornament mt-9 mb-2" aria-hidden>
          <span>I &middot; II &middot; III</span>
        </div>

        <p
          className="text-center"
          style={{
            color: "var(--ink-muted)",
            fontSize: "0.95rem",
            fontStyle: "italic",
            margin: 0,
          }}
        >
          Chapters shown in <span className="chapter-link sample" style={{minWidth: "1.6rem", height: "1.6rem", fontSize: "0.78rem"}}>1</span>{" "}
          gold are transcribed with the full Haydock commentary.
        </p>
      </div>

      <div className="mt-14">
        <BookList
          title="THE NEW TESTAMENT"
          books={NEW_TESTAMENT}
          testId="new-testament-section"
        />
      </div>

      <div className="mt-16 parchment-card p-7 text-center fade-in">
        <p
          style={{
            fontFamily: "'IM Fell English SC', serif",
            letterSpacing: "0.18em",
            color: "var(--ink-muted)",
            fontSize: "0.85rem",
            marginBottom: "0.6rem",
          }}
        >
          THE OLD TESTAMENT
        </p>
        <p
          style={{
            fontStyle: "italic",
            color: "var(--ink-soft)",
            maxWidth: "55ch",
            margin: "0 auto 1.1rem",
          }}
        >
          The full Old Testament &mdash; from Genesis through 2&nbsp;Machabees
          &mdash; is indexed on its own page.
        </p>
        <Link
          to="/old-testament"
          className="btn-ghost"
          data-testid="ot-cta"
        >
          BROWSE THE OLD TESTAMENT &rarr;
        </Link>
      </div>
    </div>
  );
}
